import {Component, OnDestroy, OnInit, signal} from '@angular/core';
import {AuthService} from "@auth0/auth0-angular";
import {Subscription} from "rxjs";
import {jwtDecode} from "jwt-decode";
import {LoadingComponent} from "../../shared/loading/loading.component";
import {ClaimTenant} from "../../core/utils/app.model";

@Component({
  selector: 'app-extension',
  standalone: true,
  imports: [LoadingComponent],
  templateUrl: './extension.component.html',
  styleUrl: './extension.component.less'
})
export class ExtensionComponent implements OnInit, OnDestroy {
  loading = signal(true);
  authenticated = signal(false);
  hasCloudProductPersona: boolean = false;
  private subscription = new Subscription();

  constructor(private authService: AuthService) {
  }

  ngOnInit() {
    console.log('LOGIN: 🧩 Extension Init');
    this.checkForAuthentication();
    this.listenForChanges();
  }

  checkForAuthentication() {
    this.subscription.add(
      this.authService.getAccessTokenSilently().subscribe({
        next: (jwtToken) => {
          const decodedToken: any = jwtDecode(jwtToken);
          const defaultPath: string = decodedToken['https://vodori.com/def'];
          const tenants: ClaimTenant[] = decodedToken['https://vodori.com/tnts'];

          // if they have a default, confirm it has a cloud persona and if so, redirect to Cloud's extension component
          if (defaultPath != null) {
            console.log('LOGIN: 🧩 - Found default in JWT:', defaultPath);

            if (defaultPath.includes('/cloud/')) {
              console.log('LOGIN: 🧩 - Redirecting to default:', defaultPath);
              this.hasCloudProductPersona = true;
              window.location.href = `/${defaultPath}/lens/extension`;
              return;
            }

            // if default is not a cloud product check if default tenant has a cloud persona we can redirect to
            const [env, _, ten] = defaultPath.split('/');
            const defaultTenantHasCloudPersona = tenants.find(t => t.et == `${env}/${ten}`)?.pUsers.some(p => p.startsWith('cloud/'));
            if (defaultTenantHasCloudPersona) {
              const url = `/${env}/cloud/${ten}/lens/extension`;
              console.log('LOGIN: 🧩 - Default tenant has Cloud persona, redirecting to:',  url);
              this.hasCloudProductPersona = true;
              window.location.href = url;
              return;
            }
          }

          // otherwise check for any tenant with a cloud persona. if there's one, redirect to Cloud's extension component
          const tenantWithCloudPersona = tenants.find(t => t.pUsers.some(p => p.startsWith('cloud/')));
          if (tenantWithCloudPersona) {
            this.hasCloudProductPersona = true;
            const [env, ten] = tenantWithCloudPersona.et.split('/');
            console.log('LOGIN: 🧩 - Defaults have no Cloud persona, redirecting to:', `/${env}/cloud/${ten}/lens/extension`);
            window.location.href = `/${env}/cloud/${ten}/lens/extension`;
            return;
          }

          console.log('LOGIN: 🧩 - User authenticated but has no Cloud persona');
          this.authenticated.set(true);
          this.loading.set(false);
        }, error: (error) => {
          console.log('LOGIN: 🧩 - Unable to fetch token, will prompt to login');
          this.loading.set(false);

          if (error?.message !== "Login required") {
            console.error('LOGIN: 🚫 - Error retrieving access token', error);
          }
        }
      })
    );
  }

  // if user leaves to log in and comes back, re-prompt the authentication check
  listenForChanges() {
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        this.checkForAuthentication();
      }
    });
  }

  returnToTenantSelector() {
    console.log('LOGIN: 🧩 - Navigating back to tenant selector');
    window.location.href = 'chrome-extension://heejmadlpimhgikldldieplegefeomkf/pages/tenant.html#refresh';
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
